import React, { useEffect, useState } from "react";
import "../Styles/style.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import { baseUrl } from "../../api/ipconfig";
import Profile from "../../images/icons/q.png";
import BlueTick from "../../images/blue-tick-success.png";
import Tooltip from "@mui/material/Tooltip";

export default function UserProfile() {
  const [isLoading, setLoading] = useState(true);
  const [newlyLaunchedCarsList, setNewlyLaunchedCarsList] = React.useState([]);
  const [userDetails, setUserDetails] = React.useState({});
  const [postId, setPostId] = useState(null);

  const extractPostIdFromUrl = (url) => {
    const parts = url.split("/");
    return parts[parts.length - 1];
  };

  useEffect(() => {
    const url = window.location.href;
    const postIdUrl = extractPostIdFromUrl(url);
    setPostId(postIdUrl);

    postId && fetchNewlyLaunchedlistData(postId);
  }, [postId]);

  const fetchNewlyLaunchedlistData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/userpostlist`, {
        params: {
          user_id: postId,
        },
      });
      setNewlyLaunchedCarsList(response?.data?.post?.data);
      setUserDetails(response?.data?.userDetail);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const history = useHistory();

  const formatPrice = (price) => {
    if (price >= 100000000000) {
      return (
        (price / 100000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Kharab"
      );
    } else if (price >= 1000000000) {
      return (
        (price / 1000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Arab"
      );
    } else if (price >= 10000000) {
      return (
        (price / 10000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Crore"
      );
    } else if (price >= 100000) {
      return (
        (price / 100000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " lacs"
      );
    } else if (price >= 1000) {
      return (
        (price / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " Thousand"
      );
    } else {
      return price.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
  };

  const openCarDetail = (id) => {
    history.push(`/vehicle-details/${id}`);
  };

  return (
    <>
      <div className="myUserDetail_Main bgUser_Detail pb-2 mb-md-3">
        <div className="container profileArea h-100 d-flex align-items-end">
          <img
            className="profilePic"
            src={Profile}
            alt="Profile Pic"
            loading="lazy"
          />
          <div className=" position-relative d-flex justify-content-center mb-2">
            <h4 className="pt-2 text-capitalize">
              {userDetails && userDetails?.name}
            </h4>
            {userDetails?.role_id === 3 && (
              <Tooltip
                title="Member"
                arrow
                placement="top"
                enterDelay={40}
                leaveDelay={200}
              >
                <img
                  src={BlueTick}
                  className="membertick"
                  alt="Blue tick"
                  srcSet=""
                />
              </Tooltip>
            )}
          </div>
        </div>
      </div>
      <div className=" newcar-main">
        <div className="container text-center ">
          <section
            className="p-3 mb-3 "
            style={{ borderRadius: 2, background: "white" }}
          >
            <div className="row">
              {newlyLaunchedCarsList.map((item, index) => (
                <div
                  className="col-lg-3 col-md-4 col-6 mb-3 p-2 cursorPointer "
                  key={`${item?.postId}`}
                  onClick={() => openCarDetail(`${item?.postId}`)}
                >
                  <div className="adPost text-start">
                    <div className="position-relative m-2">
                      <img
                        src={`${baseUrl}/public/posts/${item?.post_token}/${item?.cover}`}
                        alt={`${item?.make} ${item?.model_name}`}
                        style={{ boxShadow: "unset" }}
                        onError={(e) => {
                          e.target.src =
                            "https://gallery.famewheels.com/appgallery/no-image.png";
                        }}
                      />
                      {item?.PostTypeId === 2 && (
                        <div className="d-flex align-items-center justify-content-between position-absolute top-0 w-100 ">
                          <div className="m-0 px-2 py-1 fw-600 featured-badge text-center">
                            FEATURED
                          </div>
                        </div>
                      )}
                    </div>

                    <div className=" p-2 ">
                      <h5 className="fw-600 ad-Title color-black text-capitalize mb-1 text-center">
                        {item?.makeName} {item?.modelName} {item?.yearName}
                      </h5>
                      <h4
                        style={{ color: "#20409a" }}
                        className="fw-600 text-center adPrice mb-1"
                      >
                        <span style={{ color: "#20409a" }}>
                          <i className="fa-solid fa-location-dot me-2 color-secondary"></i>
                          {item?.cityName}
                        </span>
                      </h4>
                      <h4
                        style={{ color: "#20409a" }}
                        className="fw-600 text-center adPrice mb-1"
                      >
                        <span style={{ color: "#20409a" }}>
                          PKR {formatPrice(item?.price)}
                        </span>
                      </h4>

                      <h4 className="fw-500 text-center adPrice mt-2">
                        <span> {item?.newcarpost_launchdate}</span>
                      </h4>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
